angular
    .module('app')
    .controller('InformativeDocsCtrl', function (
        $scope,
        $rootScope,
        $timeout,
        $configService,
        $download
    ) {


        $timeout(function () {
            //albaInit();
            console.log("albaInit() forced!");
        }, 300);



        $scope.generatePrivacyDownloadLink = function (nameFile) {

            var url = '/uni/download/service-infos/' +
                encodeURIComponent(nameFile) + '/'

            $download.getGenericDownload(url)
                .then(function (response) {
                    console.log(response);
                })

        }

    });
